export default {
    methods: {
        doCopy(item){
            this.$copyText(item).then(() => {
                this.$notify({
                    group: 'foo',
                    title: 'Message',
                    text: 'Copied!'
                });
            }, function (e) {
                console.log(e)
            });
        },
        doCopyFTP (ftpDetails) {
            let detailString = 'Host: ' + ftpDetails.host + '\n' +
                'Port: ' + ftpDetails.port + '\n' + 'Mode: ' + ftpDetails.mode +
                '\nPASV: '  + ftpDetails.pasv + '\n' +  'Username: ' + ftpDetails.username + '\n' +
                'Password: ' + ftpDetails.password;
            this.doCopy(detailString);
        },
        doCopyPhpMyAdmin (details, primaryPhpMyAdmin) {
            let detailString = 'URL: ' + primaryPhpMyAdmin.url + '\n' +
                'PopUpUsername: ' + primaryPhpMyAdmin.popupUsername + '\n' + 'PopUpPassword: ' + primaryPhpMyAdmin.popupPassword + '\n'
                +'Username: ' + details.username + '\n' + 'Password: ' + details.password;
            this.doCopy(detailString);
        },
        doCopyCloudFlare (details) {
            let detailString = 'Username: ' + details.username + '\n' +
                'Password: ' + details.password + '\n' + 'UserKey: ' + details.userKey + '\n'
                +'NameServer1: ' + details.nameserver1 + '\n' + 'NameServer2: ' + details.nameserver2 + '\n'
                +'APIKey: ' + details.apiKey + '\nZone: ' + details.zone_id;
            this.doCopy(detailString);
        }
    }
}
